import { React, useState } from "react";
import CustomInput from "../../../../Core/Components/CustomInput";
import CloseIcon from "../../../../Common/Svgs/CloseIcon";

const TripSearch = ({ search, setSearch }) => {
  // const [search, setSearch] = useState("");
  const [focus, setFocus] = useState(false);

  return (
    <CustomInput
      intent="searchHome"
      prefix={<img src="/assets/icons/search.svg" alt="" className="mr-2" />}
      value={search}
      focus={focus}
      border={focus ? "success" : "none"}
      placeholder={focus ? null : "Search Trip ID"}
      onChange={(e) => setSearch(e.target.value)}
      onFocus={() => setFocus(true)}
      onBlur={() => setFocus(false)}
      suffix={
        search.length ? (
          <CloseIcon
            className="w-4 h-4 cursor-pointer stroke-dark-grey-text"
            onClick={() => {
              setSearch("");
              setFocus(false);
            }}
          />
        ) : null
      }
    />
  );
};

export default TripSearch;
